<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    roomData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      form: {
        prices: [
          {
            name: '民生店',
            petType: '10kg含以下',
            originalPrice: 3000,
            sellingPrice: 1500,
            costPrice: 900,
            additionalCharge: 350,
            status: true,
          },
          {
            name: '民生店',
            petType: '11kg-22kg',
            originalPrice: 3000,
            sellingPrice: 1500,
            costPrice: 900,
            additionalCharge: 350,
            status: true,
          },
          {
            name: '民生店',
            petType: '23kg含以上',
            originalPrice: 3000,
            sellingPrice: 1500,
            costPrice: 900,
            additionalCharge: 350,
            status: true,
          },
          {
            name: '中山店',
            petType: '10kg含以下',
            originalPrice: 3000,
            sellingPrice: 1500,
            costPrice: 900,
            additionalCharge: 350,
            status: true,
          },
          {
            name: '中山店',
            petType: '11kg-22kg',
            originalPrice: 3000,
            sellingPrice: 1500,
            costPrice: 900,
            additionalCharge: 350,
            status: true,
          },
          {
            name: '中山店',
            petType: '23kg含以上',
            originalPrice: 3000,
            sellingPrice: 1500,
            costPrice: 900,
            additionalCharge: 350,
            status: true,
          },
        ],
      },
      isDataReady: false,
      originalPrices: [],
    }
  },
  watch: {
    roomData: {
      handler(val) {
        if (val && Object.keys(val).length > 0) {
          this.form.prices = JSON.parse(JSON.stringify(val.prices))
          this.originalPrices = JSON.parse(JSON.stringify(val.prices))
          this.isDataReady = true
          this.$message.success('房價設定資料載入完成')
        }
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    ...mapGetters('hotel/setting', ['productId', 'productName']),
    isRoomsOnlyOne() {
      return this.rooms && this.rooms.length === 1
    },
  },
  methods: {
    getStepData() {
      return {
        prices: this.form.prices,
      }
    },
    exit() {
      this.$router.push('/hotel?tab1=1')
    },
    settingAllRooms() {
      this.form.prices.forEach((r) => {
        r.price = this.form.prices[0].price
        r.basePrice = this.form.prices[0].basePrice
        r.extraPrice = this.form.prices[0].extraPrice
        r.extraBasePrice = this.form.prices[0].extraBasePrice
        r.state = this.form.prices[0].state
      })
    },
    resetData() {
      this.form.prices = JSON.parse(JSON.stringify(this.originalPrices))
    },
  },
}
</script>
<template>
  <div class="outer">
    <el-form class="container" v-loading="!isDataReady" element-loading-text="載入中...">
      <hgroup>
        <el-button class="is-round" @click="exit">
          <BaseIcon name="chevron-left" icon-style="fal" class="mr-2 text-secondary" />
          返回
        </el-button>
        <h1>房價設定</h1>
      </hgroup>
      <div class="content">
        <table>
          <thead>
            <tr>
              <th>分店及分類名稱</th>
              <th>首隻入住原價</th>
              <th>首隻入住售價</th>
              <th>每加一隻原價</th>
              <th>每加一隻售價</th>
              <th>狀態</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(room, index) in form.prices">
              <tr :key="index">
                <td>
                  <div class="name-col">
                    <span class="store-name">{{ productName }}</span>
                    <span class="type-name">{{ room.categoryTitle }}</span>
                  </div>
                </td>
                <td> <el-input v-model.number="room.basePrice" type="number" :min="0" /> </td>
                <td> <el-input v-model.number="room.price" type="number" :min="0" /> </td>
                <td> <el-input v-model.number="room.extraBasePrice" type="number" :min="0" /> </td>
                <td> <el-input v-model="room.extraPrice" type="number" :min="0" /> </td>
                <td>
                  <div class="status-col">
                    <span class="status-text">{{ room.state ? '上架' : '下架' }}</span>
                    <el-switch v-model="room.state" active-color="#F37736" inactive-color="#EAEAEA" :active-value="1" :inactive-value="0" />
                  </div>
                </td>
              </tr>
              <tr v-if="index === 0">
                <td colspan="6">
                  <el-button class="is-round" :disabled="isRoomsOnlyOne" @click="settingAllRooms">
                    將設定套用至所有分類
                  </el-button>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </el-form>
  </div>
</template>

<style lang="scss" scoped>
.outer {
  overflow-y: auto;
  width: 100%;
  padding: 18px 20px;
  height: 100%;
  margin-bottom: 85px;
}
.container {
  overflow: scroll;
  width: 100%;

  hgroup {
    display: flex;
    align-items: center;
    .el-button {
      margin-right: 20px;
    }
  }

  .content {
    margin-top: 10px;
    padding: 0 20px;
    background-color: #fff;

    h2 {
      font: normal normal normal 16px/28px PingFang TC;
      letter-spacing: 2.4px;
      color: #121931;
    }

    table {
      text-align: left;
      width: 100%;
      border-collapse: collapse;
      table-layout: fixed;

      thead {
        tr {
          th {
            // background-color: #f9f9fb;
            padding: 15px 12px;
            color: #606266;
            font-weight: 500;
            font-size: 14px;
            border: none;

            &:nth-child(2) {
              width: 140px;
            }

            &:nth-child(3) {
              width: 140px;
            }

            &:nth-child(4) {
              width: 140px;
            }

            &:nth-child(5) {
              width: 140px;
            }

            &:nth-child(6) {
              width: 180px;
              text-align: center;
            }
          }
        }
      }

      tbody {
        tr {
          td {
            padding-top: 12px;
            padding-bottom: 12px;
            padding-left: 5px;
            padding-right: 5px;

            &:nth-child(1) {
              div {
                display: flex;
                flex-direction: column;
              }
            }

            &:nth-child(2) {
              width: 130px;
            }

            button {
              width: 100%;
            }
          }

          &:nth-child(n + 3) {
            border-top: 1px solid #e5e7eb;
          }
        }
      }
    }
  }
}
.name-col {
  display: flex;
  flex-direction: column;
  gap: 5px;

  .store-name {
    font-size: 14px;
    color: #333;
    font-weight: 500;
  }

  .type-name {
    font-size: 13px;
    color: #333;
  }
}

.status-col {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  padding-right: 20px;

  .status-text {
    font-size: 14px;
    color: #f37736; // Orange for '上架'
    // To implement dynamic color (gray for inactive), we'd need conditional class
  }
}

.apply-all-row {
  padding: 15px 0;
  border-bottom: 1px solid #eaeaea;
}

.apply-all-btn {
  width: 100%;
  border-radius: 4px;
  border: 1px solid #eaeaea;
  color: #606266;
  background-color: #fff;

  &:hover {
    color: #f37736;
    border-color: #f37736;
    background-color: #fff5f2;
  }
}

::v-deep .el-input__inner {
  text-align: center;
}
</style>
